<cec-breadcrumb [isVisible]="isOrganizer()"></cec-breadcrumb>

<cec-grid
  [id]="competitionId"
  [dataSource]="service"
  [hideColumns]="!isOrganizer()"
  (onButtonClicked)="onButtonClick($event)"
>
  <cec-toolbar (onButtonClicked)="onToolbarClick($event)">
    <cec-toolbar-item
      id="add"
      icon="add"
      [tooltip]="'Sign crew to the competition' | translate"
      [visible]="isOrganizer()"
    >
    </cec-toolbar-item>
    <cec-toolbar-item
      id="print"
      icon="print"
      [tooltip]="'Download competitor cards' | translate"
      [visible]="isOrganizer()"
    >
    </cec-toolbar-item>
  </cec-toolbar>
</cec-grid>

<cec-competition-registration-dialog
  #registrationDialog
  [type]="'organizer'"
></cec-competition-registration-dialog>

<cec-confirmation-dialog
  messageKey="LogoutCrewFromCompetition"
  (onButtonClicked)="onLogoutButtonClick($event)"
></cec-confirmation-dialog>

<cec-info-dialog
  [textAreaLabelKey]="infoDialogTextAreaLabelKey"
  (onButtonClicked)="authorNoteUpdate($event)"
></cec-info-dialog>
